export default "__VITE_ASSET__5609c67a__"